document.addEventListener("DOMContentLoaded", function() {
  var descriptionContainer = document.getElementById("description-container");
  var descriptionElement = document.getElementById("collection-description");
  var readMoreElement = document.getElementById("read-more");
  var readLessElement = document.getElementById("read-less");
  var fullDescriptionElement = document.getElementById("full-collection-description"); // Add this line

  // Get the full description text
  var fullText = descriptionElement.textContent.trim();

  // Store the full HTML description
  var fullHTML = descriptionElement.innerHTML; // Add this line

  // Check if the description is longer than 150 characters
  if (fullText.length > 150) {
    // Truncate the text to 150 characters
    var truncatedText = fullText.substring(0, 150);

    // Find the last space before 150 characters to ensure a complete word
    var lastSpaceIndex = truncatedText.lastIndexOf(' ');
    truncatedText = truncatedText.substring(0, lastSpaceIndex);

    // Add the ellipsis
    truncatedText += '...';

    // Set the truncated text as the initial content
    descriptionElement.innerHTML = truncatedText; // Use innerHTML

    // Show the "Read More" button
    readMoreElement.style.display = 'inline';

    // Add event listener to handle the "Read More" click
    readMoreElement.addEventListener('click', function(event) {
      event.preventDefault();

      // Set the full description HTML
      descriptionElement.innerHTML = fullHTML; // Use innerHTML

      // Hide the "Read More" button
      readMoreElement.style.display = 'none';

      // Show the "Read Less" button
      readLessElement.style.display = 'inline';

      // Adjust the container height to accommodate the full text
      descriptionContainer.style.height = 'auto';
    });

    // Add event listener to handle the "Read Less" click
    readLessElement.addEventListener('click', function(event) {
      event.preventDefault();

      // Set the truncated text as the content
      descriptionElement.innerHTML = truncatedText; // Use innerHTML

      // Show the "Read More" button
      readMoreElement.style.display = 'inline';

      // Hide the "Read Less" button
      readLessElement.style.display = 'none';

      // Reset the container height
      descriptionContainer.style.height = null;
    });
  } else {
    // Hide the "Read More" button if the description is not longer than 150 characters
    readMoreElement.style.display = 'none';
  }
});
